export default "__VITE_ASSET__rlfFnXd4__"